import { getCurrentInstance, onMounted, ref } from 'vue'
import { useDialog } from './useDialog'
import { useMenuMessage } from '../../messages/useMenuMessage'
import { useDialogMessage } from '../../messages/useDialogMessage'
import { useInactiveTimeout } from '../timeout/useInactiveTimeout'
import { config } from '@/core/config'
import type { AbbotDialogProps } from './useAbbotDialog'

export function useAbbotDialogWithTimeout(props: AbbotDialogProps) {
  const { id, autoOpen } = props
  const dialog = useDialog(id)
  const abbotRef = ref<HTMLDivElement>()
  const lang = id.endsWith('-th') ? 'th' : 'en'
  const section = ref('')
  const detailId = ref(0)

  const dialogMessage = useDialogMessage(id)
  const dialogTimeout = useInactiveTimeout(id + '.dialog', config.abbotSettings.dialogTimeoutSec *1000)

  onMounted(() => {
    abbotRef.value = <HTMLDivElement>getCurrentInstance()?.refs.abbotRef
  })

  function showListsSection() {
    dialogTimeout.reset()
    //------------------
    section.value = 'lists'
  }

  function showDetailSection(idx: number) {
    dialogTimeout.reset()
    //------------------
    detailId.value = idx
    section.value = 'detail'
  }

  dialog.onDialogOpened(() => {
    dialogTimeout.reset()
    //------------------
    const closeId = id.endsWith('-th') ? id.replace('-th', '-en') : id.replace('-en', '-th')
    dialogMessage.CloseDialogCommand(closeId)
    //------------------
    section.value = 'lists'
    detailId.value = 0
  })

  dialog.onDialogClosed(() => {
    dialogTimeout.stop()
    //------------------
    section.value = ''
    detailId.value = 0
  })

  dialogTimeout.onTimeout(() => {
    dialog.close()
  })

  onMounted(() => {
    if (autoOpen) {
      setTimeout(() => {
        dialog.open()
      }, 800)
    }
  })

  return {
    id,
    lang,
    detailId,
    section,
    showListsSection,
    showDetailSection,
    ...dialog,
  }
}
